import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';

interface IProps {
  code: any;
}

export default class Jivo extends PureComponent<IProps> {
  componentDidMount() {
    const script = document.createElement('script');
    script.innerHTML = `
      (function(){ var widget_id = '${this.props.code}';var d=document;var w=window;function l(){
      var s = document.createElement('script'); s.type = 'text/javascript'; s.async = true; s.src = '//code.jivosite.com/script/widget/'+widget_id; var ss = document.getElementsByTagName('script')[0]; ss.parentNode.insertBefore(s, ss);}if(d.readyState=='complete'){l();}else{if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();
    `;

    // eslint-disable-next-line react/no-find-dom-node
    ReactDOM.findDOMNode(this).appendChild(script);
  }

  componentWillUnmount() {
    const elem = document.getElementById('jivo-iframe-container');
    elem?.parentNode.removeChild(elem);
    Object.keys(window)
      .filter(key => key.includes('jivo'))
      .forEach(key => delete (window as any)[key]);
    const jivo = document.querySelectorAll('jdiv');
    jivo.forEach(value => value.remove());
  }

  render() {
    return <span></span>;
  }
}
